import { render } from "./CardText.vue?vue&type=template&id=13969c32"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13969c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13969c32', __exports__)) {
    api.reload('13969c32', __exports__)
  }
  
  module.hot.accept("./CardText.vue?vue&type=template&id=13969c32", () => {
    api.rerender('13969c32', render)
  })

}


export default __exports__